import { currentStoreView } from '@vue-storefront/core/lib/multistore'
import dayjs from 'dayjs'
import timezone from 'dayjs/plugin/timezone'
import utc from 'dayjs/plugin/utc'

dayjs.extend(timezone)
dayjs.extend(utc)

export default {
  data () {
    return {
      dateLoading: true
    }
  },
  filters: {
    dateFilter (date) {
      return this.parseDate(date)
    }
  },
  mounted () {
    this.dateLoading = false
  },
  methods: {
    parseDate (
      date,
      separator = ' ',
      dateOptions = null
    ) {
      if (!date) return ''
      const currentLocale = currentStoreView().i18n.defaultLocale
      let time = dayjs.tz(date, 'UTC').tz('Europe/Stockholm').format('HH:mm')
      separator = separator === ' ' ? separator : ' ' + separator + ' '
      dateOptions = dateOptions || { day: 'numeric', month: 'short', year: 'numeric' }

      // Fix for date format on iOS
      if (date[10] === ' ') {
        date = date.split('')
        date[10] = 'T'
        date = date.join('')
      }
      date = new Date(date)

      return date.toLocaleDateString(currentLocale, dateOptions).split('.').join('').toString() + separator + time
    }
  }
}
